import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { MAIN_CONTENT } from 'constant'

const MainSearchResult = ({
  children
}) =>
  <Wrapper id={ MAIN_CONTENT } tabIndex="-1" data-max-width data-max-width-padding>
    { children }
  </Wrapper>

MainSearchResult.propTypes = {
  children: PropTypes.node
}

export default MainSearchResult

const Wrapper = styled.main`
  ${Mixin.responsive('padding', '0 50px 0', '0')}
`
